import { render, staticRenderFns } from "./GenericInputSimple.vue?vue&type=template&id=5b55b3ee&scoped=true"
import script from "./GenericInputSimple.vue?vue&type=script&lang=js"
export * from "./GenericInputSimple.vue?vue&type=script&lang=js"
import style0 from "./GenericInputSimple.vue?vue&type=style&index=0&id=5b55b3ee&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b55b3ee",
  null
  
)

export default component.exports